import React from 'react';

/**
 * HomeSidebar - Wrapper component for home page sidebar content
 * 
 * Typically contains: LiveDrawCard, PartnerBanner, Charity component
 * 
 * @param {React.ReactNode} children - Sidebar content (LiveDrawCard, PartnerBanner, etc.)
 * @param {string} className - Additional CSS classes
 * @param {boolean} sticky - Enable sticky positioning
 * @param {number|string} gap - Spacing between items (default: 6)
 */
export const HomeSidebar = ({ 
  children, 
  className = '', 
  sticky = false,
  gap = 6 
}) => {
  // Map gap prop to Tailwind spacing classes
  const gapClasses = {
    2: 'space-y-2',
    3: 'space-y-3',
    4: 'space-y-4',
    5: 'space-y-5',
    6: 'space-y-6',
    8: 'space-y-8',
  };

  const spacingClass = gapClasses[gap] || 'space-y-6';
  
  const stickyClasses = sticky 
    ? 'sticky top-4 self-start' 
    : '';

  return (
    <aside 
      className={`
        flex flex-col
        ${spacingClass}
        ${stickyClasses}
        ${className}
      `.trim().replace(/\s+/g, ' ')}
    >
      {children}
    </aside>
  );
};

export default HomeSidebar;
